<template>
  <!-- 确认套餐 -->
  <div class="messageWrap confirmPackage">
    <p class="messageTitle">{{ $t("enroll.affirm.stepTitle01") }}</p>
    <div class="mt20 container">
      <div class="singleWrap">
        <p class="singleTitle">{{ $t("creation.messageTitle") }}</p>
        <div class="clearfix singleContent">
          <p class="fl singleText">
            <span class="mr6">{{ $t("creation.applicant") }}:</span>
            <span>{{ applymentDetail.applicantName }}</span>
          </p>
          <p class="fl singleText">
            <span class="mr6">{{ $t("creation.mobile") }}:</span>
            <span>{{ applymentDetail.applicantPhone }}</span>
          </p>
          <p class="fl singleText">
            <span class="mr6">{{ $t("creation.email") }}:</span>
            <span>{{ applymentDetail.applicantEmail }}</span>
          </p>
          <p class="fl singleText">
            <span class="mr6">{{ $t("creation.applicantRole") }}:</span>
            <span>
              {{ getGlobalLabel("applicantRoleTypeList", applymentDetail.applicantPosition) }}
            </span>
          </p>
          <p class="fl singleText">
            <span class="mr6">{{ $t("creation.residentialAddress") }}:</span>
            <span>{{ applymentDetail.residentialAddress }}</span>
          </p>
        </div>
      </div>
      <div class="pb0 singleWrap">
        <p class="singleTitle">{{ $t("creation.locationTitle") }}</p>
        <div class="clearfix singleContent">
          <!-- <span class="mr6">{{$t('creation.country')}}:</span> -->
          <p class="fl singleText">
            {{ getGlobalLabel("supportServiceCountryList", applymentDetail.country) }}
          </p>
        </div>
      </div>
      <!-- 操作类型 - 后台业务人员 -->
      <div
        class="pt60 pb0 singleWrap"
        v-if="(applymentDetail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || applymentDetail.businessType == 'FUND_ADMIN_CUSTOMIZED') && isCoordinator"
      >
        <p class="singleTitle">{{ $t("creation.operatingType") }}</p>
        <div class="clearfix singleContent">
          <p class="fl singleText" v-if="applymentDetail.isRenew">
            {{ $t("creation.renewService") }}
          </p>
          <p class="fl singleText" v-if="applymentDetail.isLaterService">
            {{ $t("creation.increaseService") }}
          </p>
          <p class="fl singleText" v-if="applymentDetail.isRenew == false && applymentDetail.isLaterService == false">
            {{ $t("creation.other") }}
          </p>
        </div>
      </div>
      <!-- 选择套餐 -->
      <div class="pt60 pb0 singleWrap">
        <p class="singleTitle">{{ $t("creation.comboTitle") }}</p>
        <!-- 主体类型 -->
        <p class="singleText">
          <span class="mr6">{{ $t("creation.entityType") }}:</span>
          <span>
            {{ getByCountryLabel("businessGenreData", applymentDetail.businessGenre) }}
          </span>
        </p>
        <!-- 业务类型 -->
        <p class="singleText">
          <span class="mr6">{{ $t("creation.businessType") }}:</span>
          <span>
            {{ getByCountryLabel("businessGenreData", applymentDetail.businessGenre, applymentDetail.businessType) }}
          </span>
        </p>
        <!-- 促销编号 -->
        <template v-if="applymentDetail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || applymentDetail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
          <p class="singleText">
            <span class="mr6">{{ $t("creation.promotion") }}:</span>
            <span>
              {{ applymentDetail.promotionCode }}
            </span>
          </p>
        </template>
        <div class="hg10"></div>

        <!-- 套餐、自定义套餐、定制化服务-报价(列表) -->
        <selected-package />
      </div>

      <!-- 服务报价书 -->
      <div
        class="pb0 singleWrap"
        v-if="
          (applymentDetail.businessType == 'COMPREHENSIVE_CUSTOMIZED' || applymentDetail.businessType == 'FUND_ADMIN_CUSTOMIZED') &&
          applymentDetail.applymentStatus != 'DRAFT' &&
          applymentDetail.applymentStatus != 'INQUIRING' &&
          applymentDetail.applymentStatus != 'QUOTING' &&
          applymentDetail.applymentStatus != 'QUOTATION_AUDITING' &&
          applymentDetail.applymentStatus != 'QUOTATION_AUDIT_FAIL' &&
          applymentDetail.feeLetterUrls &&
          applymentDetail.feeLetterUrls.length > 0
        "
      >
        <p class="singleTitle">{{ $t("enroll.quotation.feeLetter") }}</p>
        <div class="clearfix singleContent">
          <p v-for="(item, idx) in applymentDetail.feeLetterUrls" :key="`feeLetterUrls${idx}`">
            <a :href="item.url" target="_blank" class="fs14 blue">{{ item.name }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectedPackage from "./components/SelectedPackage";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    SelectedPackage,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    ...mapState("user", ["isCoordinator"]),
    ...mapGetters("constant", ["getGlobalLabel", "getByCountryLabel"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.messageTitle {
  border-radius: 2px;
  font-size: 18px;
  line-height: 1em;
  font-weight: bold;
}

.singleWrap {
  padding-bottom: 60px;
}

.singleTitle {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  padding-bottom: 10px;
}

.singleText {
  font-size: 12px;
  line-height: 22px;
  margin-right: 30px;
  word-wrap: break-word;
  word-break: break-all;
}

.confirmPackage {
  ::v-deep {
    .orange {
      color: #000 !important;
    }

    .blueDark {
      color: #0000cd !important;
    }
  }
}
</style>
